module.exports = __webpack_public_path__ + "static/media/activity-fun-quizzes.89176471.png";